import { MoneyDisplay } from '@/components/ui/MoneyDisplay';
import type { LedgerValue } from '@/api/types';

interface LedgerValueDisplayProps {
    latestValue: LedgerValue | null | undefined;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

/**
 * Displays a ledger's value with optional original currency.
 * Shows:
 * - Primary: Converted value in display currency
 * - Secondary (muted, smaller): Original value ONLY if originalCurrency !== displayCurrency
 */
export function LedgerValueDisplay({
    latestValue,
    size = 'md',
    className = '',
}: LedgerValueDisplayProps) {
    const showOriginal =
        latestValue &&
        latestValue.originalCurrency &&
        latestValue.displayCurrency &&
        latestValue.originalCurrency !== latestValue.displayCurrency;

    return (
        <div className="flex flex-col items-end justify-center h-[36px] select-text" data-no-dnd="true">
            <MoneyDisplay
                value={latestValue?.convertedValue ?? null}
                size={size}
                className={`leading-tight ${className}`}
            />
            {showOriginal && (
                <MoneyDisplay
                    value={latestValue.originalValueDecimal}
                    currency={latestValue.originalCurrency}
                    size="sm"
                    className="text-gray-500 dark:text-gray-400 leading-tight"
                />
            )}
        </div>
    );
}
